import { createSearchParams } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

export enum From {
  EvaluationCompletion = 'evaluation-completion',
}

type Navigation = ReturnType<typeof useNavigation>['navigation']

export const completedReviewsUrl = (navigation: Navigation, reviewId: number, from?: From) => {
  const searchParams = `?${createSearchParams({ myReviewsPanel: 'open', ...(from && { from }) })}`

  return (
    navigation.performanceProcess.reviews.review.fullPath({
      reviewId,
    }) + searchParams
  )
}

export const peerAssignmentUrl = (navigation: Navigation, reviewId: number) => {
  return (
    navigation.performanceProcess.reviews.review.fullPath({
      reviewId,
    }) + '?peerAssignmentPanel=open'
  )
}
